const RouteConstants = Object.freeze({
    HOME: "/",
    ABOUT_PRODUCTS: "/about-products",
    WIRES: "/wires",
    INDRASON_WIRE: "/brand/indrason",
    WIRE_COLLECTION: "/products/wires",
    FANS: "/fans",
    ACCESSORIES: "/accessories",
    ORBIT_STAR: "/orbit-star",
});

export default RouteConstants;
